import {Item} from '../../models/Item';
import {AbstractMainPlugin} from '../AbstractMainPlugin';
import {STATIC_FIELD_IN_DATE, STATIC_FIELD_OUT_DATE} from 'src/app/interfaces/constants';
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';
import {appInjector} from '@src/app/classes/appInjector';


export class StaticParamsPlugin extends AbstractMainPlugin {

  private im: ItemManagerService;

  constructor(item: Item) {
    super(item);
    this.im = appInjector.get(ItemManagerService);
    this.initListeners();
  }

 private initListeners(){
    this.item.getSubject(Item.SUBJECT_INPUTS_CHANGED).subscribe((method)=>{
      if (this.item.config.isCopy){
        return this.im.getItemById(this.item.config.getCopyParentId).getSubject(Item.SUBJECT_INPUTS_CHANGED).next(method);
      }
      this[method]();
    })

   this.item.getSubject(Item.EXECUTE_STATIC_INPUTS_METHOD).subscribe((method)=>{
     this[method]();
   })
  }

  addTimeline() {
    this.item.config.createInputValue('__timeline', {label: 'Timeline', value: ''});
  }

  addVendors(){
    this.item.config.createInputValue('__vm_vendor_zone', {label: 'Vendor Zone', value: ''});
    this.item.config.createInputValue('__vm_power_details', {label: 'Power details, kw', value: ''});
    this.item.config.createInputValue('__vm_name', {label: 'Vendor Name', value: ''});
    this.item.config.createInputValue('__vm_status', {label: 'Status', value: 'Available'});
    this.item.config.createInputValue('__vm_furniture', {label: 'Furniture', value: ''});
    this.item.config.createInputValue('__vm_fresh_water', {label: 'Fresh water ', value: 'no'});
    this.item.config.createInputValue('__vm_grey_water', {label: 'Grey water', value: 'no'});
    this.item.config.createInputValue('__vm_internet', {label: 'Wi-fi / Internet', value: 'no'});
  }

  addSupplier(){
    this.item.config.createInputValue('__supplier', {label: 'Supplier', value: ''});
  }

  addCost(){
    this.item.config.createInputValue('__cost', {label: 'Cost', value: ''});
  }

  addInOutDates() {
    this.item.config.createInputValue(STATIC_FIELD_IN_DATE, {label: 'In Date', date: null});
    this.item.config.createInputValue(STATIC_FIELD_OUT_DATE, {label: 'Out Date', date: null});
  }

  addUeLevelAndFloor(){
    this.item.config.createInputValue('__ue_level', {label: 'UE Level', value: '', isNaN: true});
    this.item.config.createInputValue('__ue_floor', {label: 'UE Floor', value: '', isNaN: true});
  }

  removeTimeline(){
    this.item.config.removeInput('__timeline');
  }

  removeSupplier(){
    this.item.config.removeInput('__supplier');
  }

  removeCost(){
    this.item.config.removeInput('__cost');
  }

  removeInOutDates(){
    this.item.config.removeInput('__in_date');
    this.item.config.removeInput('__out_date');
  }

  removeUe(){
    this.item.config.removeInput('__ue_level');
    this.item.config.removeInput('__ue_floor');
  }

  removeVendors(){
    this.item.config.removeInput('__vm_vendor_zone');
    this.item.config.removeInput('__vm_power_details');
    this.item.config.removeInput('__vm_name');
    this.item.config.removeInput('__vm_status');
    this.item.config.removeInput('__vm_furniture');
    this.item.config.removeInput('__vm_fresh_water');
    this.item.config.removeInput('__vm_grey_water');
    this.item.config.removeInput('__vm_internet');
  }
}
